function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.499999 20.5C0.499999 18.9241 0.810387 17.3637 1.41344 15.9078C2.0165 14.4519 2.90041 13.129 4.01472 12.0147C5.12902 10.9004 6.45189 10.0165 7.9078 9.41345C9.3637 8.81039 10.9241 8.5 12.5 8.5C14.0759 8.5 15.6363 8.81039 17.0922 9.41345C18.5481 10.0165 19.871 10.9004 20.9853 12.0147C22.0996 13.129 22.9835 14.4519 23.5866 15.9078C24.1896 17.3637 24.5 18.9241 24.5 20.5L18.5 20.5C18.5 19.7121 18.3448 18.9319 18.0433 18.2039C17.7417 17.4759 17.2998 16.8145 16.7426 16.2574C16.1855 15.7002 15.5241 15.2583 14.7961 14.9567C14.0681 14.6552 13.2879 14.5 12.5 14.5C11.7121 14.5 10.9319 14.6552 10.2039 14.9567C9.47594 15.2583 8.81451 15.7002 8.25736 16.2574C7.70021 16.8145 7.25825 17.4759 6.95672 18.2039C6.65519 18.9319 6.5 19.7121 6.5 20.5L0.499999 20.5Z",
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.499954 20.5C0.499954 18.9241 0.810344 17.3637 1.4134 15.9078C2.01646 14.4519 2.90037 13.129 4.01467 12.0147C5.12898 10.9004 6.45184 10.0165 7.90775 9.41345C9.36366 8.81039 10.9241 8.5 12.5 8.5C14.0758 8.5 15.6362 8.81039 17.0922 9.41345C18.5481 10.0165 19.8709 10.9004 20.9852 12.0147C22.0995 13.129 22.9835 14.4519 23.5865 15.9078C24.1896 17.3637 24.2488 17.7858 24.3819 18.7394L18.3974 19.4396C18.3413 19.0118 18.2132 18.6143 18.0432 18.2039C17.7417 17.4759 17.2997 16.8145 16.7426 16.2574C16.1854 15.7002 15.524 15.2583 14.7961 14.9567C14.0681 14.6552 13.2879 14.5 12.5 14.5C11.712 14.5 10.9318 14.6552 10.2039 14.9567C9.4759 15.2583 8.81446 15.7002 8.25731 16.2574C7.70016 16.8145 7.25821 17.4759 6.95668 18.2039C6.65515 18.9319 6.49995 19.7121 6.49995 20.5L0.499954 20.5Z",
  fill: "#75B943"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 19.5,
  r: 2,
  fill: "#D9D9D9"
});

function SvgCallQualityGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallQualityGood);
export default __webpack_public_path__ + "static/media/call_quality_good.6ade34b2.svg";
export { ForwardRef as ReactComponent };